<template>
    <!--    the parent route has div row and col-12 specified-->

    <np-skeleton v-if="!objectIsNotEmpty(quote) && !objectIsNotEmpty(merchant)" :type="'forms'"></np-skeleton>
    <div v-else>
        <np-application-breadcrumb :crumbs="tabsToRender" :mode="'pagecrumb'"></np-application-breadcrumb>
        <router-view></router-view>
    </div>

</template>

<script>

    import {NPSkeleton,} from "../../../../js/netpify/components";
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import NPAppBreadcrumb from "../../../components/np-application-breadcrumb.vue";
    import * as types from "../../../stores/constants";

    import {mapActions, mapState} from "pinia";
    import useApplicationStore from "../../../stores/application_module";

    export default {
        name: "ReviewAndSignature",
        mixins: [utilMixin, applicationMixin],
        components: {
            'np-application-breadcrumb': NPAppBreadcrumb,
            'np-skeleton': NPSkeleton,
        },
        data() {
            return {
                page_label: 'tab_review',
                currentRouteId: 0,
                // tabsToRender:[],
                sub_tabs: [
                    {
                        // class: "btn btn-default",
                        display: true,
                        // icon: "flaticon-cogwheels12",
                        is_active: true,
                        is_open: false,
                        entity_type: 1,
                        component_name: 'Review',
                        short_label: "review",
                        label: "tab_review",
                        // lang_key: "tab_review",
                        tab_id: "tab_review",
                        url: "",
                    },
                    {
                        // class: "btn btn-default",
                        display: true,
                        // icon: "flaticon-cogwheels12",
                        is_active: true,
                        is_open: false,
                        entity_type: 1,
                        component_name: 'ValidationErrors',
                        short_label: "validation_errors",
                        label: "tab_validation_errors",
                        // lang_key: "tab_validation_errors",
                        tab_id: "tab_validation_errors",
                        url: "errors",
                    }
                ],
                routes: [],
            }
        },
        beforeRouteEnter: function (to, from, next){

            next ( vm => {
                //done to reload the data to fix  ELT 19 showing unselected terminals
                ///should only affect edit pages because view parent will refetch the quote data
                // and only have selected terminals.
                // if (location.pathname.includes('/edit/')) {
                    vm.refetchQuoteData()
                // }
                if (!vm.objectIsNotEmpty(vm.quote) && !vm.isConvertedQuote){ //close this route when quote hasn't been converted
                    // vm.$router.push({ path: `${vm.application_root_path}business/`})
                }
                vm.setAppPageTitle(vm.page_label)
            })
        },

        mounted: function () {
            // Init currentRouteId from URL
            this.refreshCurrentRouteId(this.$router.currentRoute);

            // Handle manual page change
            this.$router.afterEach((to, from) => {
                this.refreshCurrentRouteId(to)
            })
        },
        computed: {
            ...mapState(useApplicationStore,{
                validation_errors: 'validation_errors',
            }),
            tabsToRender: function () {
                let tabs = [];
                let has_error = this.merchant.has_validation_errors == '1';
                let sub_tabs = this.jsonCopy(this.sub_tabs);
                sub_tabs.forEach(obj => {
                    obj.url = this.application_root_path + 'review/' + obj.url;
                    // Disable sub-tab if the path has 'add' to avoid navigation when data still loading
                    let path_has_add = obj.url.includes('add');
                    if (path_has_add) {
                        obj.is_active = false;
                    }
                    if (obj.tab_id === 'tab_validation_errors') {
                        if (!!has_error) {
                            tabs.push(obj)
                        }
                    } else {
                        tabs.push(obj)
                    }
                })

                return tabs;
            },
            parameters: function () {
                return this.$parent.parameters;
            },
            isFirstPage: function () {
                return this.currentRouteId === 0
            },
        },
        methods: {
            ...mapActions(useApplicationStore, [types.COMMIT_APPLICATION, types.GET_MERCHANT_VALIDATION_ERRORS, types.FETCH_QUOTE_DATA]),
            ...mapActions(useApplicationStore, [types.SET_MERCHANT_DATA, types.SET_QUOTE_DATA]),
            refreshCurrentRouteId: function (currentPath) {
                let route_id = this.tabsToRender.findIndex(route => route.url === currentPath.path);
                this.currentRouteId = route_id !== -1 ? route_id : 0;
            },
            backPage: function () {
                let prev_route = {};
                if (this.currentRouteId !== 0) {
                    prev_route = this.tabsToRender[this.currentRouteId - 1];

                    this.$router.push({path: prev_route.url});
                }
            },
            nextPage: function () {
                let next_route = {};
                if (this.currentRouteId < this.tabsToRender.length - 1) {
                    next_route = this.tabsToRender[this.currentRouteId + 1];
                } else {
                    //move to next step.
                    this.$router.push({path: `${this.application_root_path}business_details`});
                }
                this.$router.push({path: next_route.url})
            },
            refetchQuoteData: async function (){
                let app_reference = this.$route.params.application_reference;

                if (!!this.merchant_user_access && this.merchant_user_access.hasOwnProperty('application')){
                    let  application = this.merchant_user_access.application.find(obj => {
                           return obj.application_reference === app_reference
                    })

                    if (!!application){
                        let payload = {
                            'user_external_id': this.user.user_external_id,
                            'quote_external_id': application.quote_external_id,
                        }

                        //fetch and commit Quote Data
                        await this[types.FETCH_QUOTE_DATA](payload);
                    }
                }
            }
        },
        watch: {
            'merchant.has_validation_errors': {
                immediate: true,
                handler: function (val) {
                    const payload = {
                        application_reference: this.merchant.application_reference
                    };
                    // let tabs = this.jsonCopy(this.sub_tabs);
                    // this.tabsToRender = tabs.reduce((tabs_array, tab) => {
                    //     tab.url = this.application_root_path + 'review/' + tab.url;
                    //     if (tab.tab_id == "tab_validation_errors" && val == '1') {
                    //         tabs_array.push(tab);
                    //     } else if (tab.tab_id != "tab_validation_errors") {
                    //         tabs_array.push(tab);
                    //     }
                    //     return tabs_array;
                    // }, []);
                    if (val == '1' && this.validation_errors.length == 0) {
                        this[types.GET_MERCHANT_VALIDATION_ERRORS](payload);
                    }
                },
            }
        }
    }
</script>

<style scoped>
</style>